import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {forkJoin, Observable} from 'rxjs';


import {CommonTransformationService, LabelChangeTransactionType, QueryResult} from '@app/shared';
import {DelegationType} from 'app/main/delegation/delegation';
import {map} from "rxjs/operators";

@Injectable()
export class DelegationDataService {

  constructor(private http: HttpClient, private transform: CommonTransformationService) {
  }

  getDelegatableTxnsAsDropdown(): Observable<SelectItem[]> {
    const url = '/delegation/txns/self';

    return this.http.get<QueryResult>(url).pipe(map(res => {
      return this.transform.convertToDropDown("name", res.list, "name", false, null, null, null, LabelChangeTransactionType);
    }));
  }

  getDelegation(type: string): Observable<any> {
    let url: string = `/delegation/profiles/self`;

    if (type != DelegationType.Self) {
      url = `/delegation/delegates/self?type=${type}`;
    }
    return this.http.get(url);
  }

  getDelegationFJ(): Observable<any> {
    const approvalUrl = `/delegation/delegates/self?type=${DelegationType.Approval}`;
    const submissionUrl = `/delegation/delegates/self?type=${DelegationType.Submission}`;
    const selfUrl = `/delegation/profiles/self`;

    return forkJoin(
      this.http.get(approvalUrl),
      this.http.get(submissionUrl),
      this.http.get(selfUrl)
    );
  }

  saveDelegation(body: any): Observable<any> {
    const url = '/delegation/profiles/self';
    return this.http.post(url, body);
  }
}
